var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-ticket-offer-type-icon-variant-1 d-flex flex-row align-center",class:_vm.offerClass},[_c(_vm.offerIcon,{tag:"component",staticClass:"mr-1"}),_vm._v(" "+_vm._s(_vm.offerLabel)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }